import Widget from '../Interfaces/Widget';

const WidgetState: Widget[] = [];

export default WidgetState;